<template lang="pug">
page-template.page-contact(title="Contato")
  grid-container.justify-content-center(cols="auto", cols-sm="50% 50%")
    .ml-0.ml-sm-auto
      custom-title.mb-3(type="section", simple) Fale Conosco
      contact-us(:action="server + '/rest/email/contact-us'")
    div
      grid-container(cols="auto", cols-lg="auto auto")
        v-card.text-body-2.mb-6.mb-sm-2.pa-4.d-flex.flex-column(
          v-for="({ sector, name, tel, email }, i) in staff",
          :key="i",
          outlined
        )
          .font-weight-bold {{ sector }}
          div(v-if="name") {{ name }}
          a.text-decoration-none.black--text.page-contact-list-item-link(
            v-if="tel",
            :href="getWhatsappLinkFromPhone(tel)",
            target="_blank"
          )
            v-icon(color="grey darken-3", small, left) fab fa-whatsapp
            span {{ tel }}
          a.text-decoration-none.black--text.page-contact-list-item-link(
            v-if="email",
            :href="'mailto:' + email",
            target="_blank"
          )
            v-icon(color="grey darken-3", small, left) fas fa-envelope
            span {{ email }}
  .mt-8
    custom-title.mb-3.text-center.mb-5(center) Vendedores
    .seller-container
      v-card.seller-item.d-flex(
        v-for="({ title, img, whatsapp }, i) in sellers",
        :key="i",
        :href="getWhatsappLinkFromPhone(whatsapp)",
        target="_blank",
        max-width="300px",
        outlined
      )
        img(:src="files + img", :alt="title", :title="title", loading="lazy")
</template>

<script>
import PageTemplate from "@/components/templates/Page.vue";
import ContactUs from "@/components/forms/ContactUs";
import CustomTitle from "@/components/others/CustomTitle";
import {
  getTelLinkFromPhone,
  getWhatsappLinkFromPhone,
} from "@/components/utils.js";

export default {
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    staff() {
      return this.$rest("staff").list;
    },
    sellers() {
      return this.$rest("sellers").list;
    },
  },
  methods: {
    getTelLinkFromPhone,
    getWhatsappLinkFromPhone,
  },
  beforeCreate() {
    this.$rest("sellers").get();
  },
  components: {
    PageTemplate,
    ContactUs,
    CustomTitle,
  },
};
</script>

<style>
.page-contact-list-item-link:hover {
  transform: scale(1.01);
}
.seller-container {
  display: grid;
  grid-template-columns: repeat(3, 300px);
  gap: 16px;
  justify-content: center;
}
.seller-item img {
  width: 100%;
  object-fit: cover;
}
@media screen and (max-width: 960px) {
  .seller-container {
    grid-template-columns: 300px 300px;
  }
}

@media screen and (max-width: 600px) {
  .seller-container {
    grid-template-columns: 300px;
  }
}
</style>
